// Emlak "Bulunduğu Kat" değerlerinin sıralı listesi (en alttan en üste).
// API tarafındaki src/config/floorOrder.js ile BİREBİR aynı olmalı; buyer kat
// aralığı bu listenin ordinal index'i üzerinden ifade edilir.
export const FLOOR_ORDER = [
  "Giriş Altı Kot 4",
  "Giriş Altı Kot 3",
  "Giriş Altı Kot 2",
  "Giriş Altı Kot 1",
  "Bodrum Kat",
  "Zemin Kat",
  "Bahçe Katı",
  "Yüksek Giriş",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6-10 arası",
  "11-20 arası",
  "21 ve üzeri",
  "Çatı Katı",
];

// Label -> ordinal index. Listede yoksa null.
export const floorIndex = (label) => {
  const i = FLOOR_ORDER.indexOf(String(label));
  return i === -1 ? null : i;
};

// Ordinal index -> label. Aralık dışıysa null.
export const floorLabel = (index) => {
  const i = Number(index);
  return Number.isInteger(i) && i >= 0 && i < FLOOR_ORDER.length
    ? FLOOR_ORDER[i]
    : null;
};
